import { useEffect } from "react";
import _ from "lodash";
import store from "../../store";

/**
 * Debounced fallback that auto-closes the loader if a request hangs too long.
 */
const defaultCloseLoader = _.debounce(() => {
  const state = store.getState();
  if (_.get(state, "appearance.isLoading.length")) {
    store.dispatch({
      type: `APPEARANCE:SET_LOADING`,
      payload: {},
    });
  }
}, 60000);

/**
 * Hook to set the global loading overlay state.
 * Pass any truthy value to show and falsy to hide.
 */
export const useSetLoading = (value: unknown) => {
  useEffect(() => {
    store.dispatch({
      type: `APPEARANCE:SET_LOADING`,
      payload: {
        value,
      },
    });
    defaultCloseLoader();
  }, [value]);
};
